import { render } from "./QuestionnaireAndroid.vue?vue&type=template&id=7f897eab&scoped=true&ts=true"
import script from "./QuestionnaireAndroid.vue?vue&type=script&lang=ts"
export * from "./QuestionnaireAndroid.vue?vue&type=script&lang=ts"

import "./QuestionnaireAndroid.vue?vue&type=style&index=0&id=7f897eab&scoped=true&lang=scss"

import exportComponent from "/app/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f897eab"]])

export default __exports__